import React, { createContext, type ReactNode, useRef, useState } from 'react';

export type AppLayoutContextType = {
  sidebarIsOpen: boolean;
  sidebarIsFixed: boolean;
  scrollRef: React.RefObject<HTMLDivElement> | null;
  setSidebarIsOpen: (value: boolean | ((prevVar: boolean) => boolean)) => void;
  setSidebarIsFixed: (value: boolean | ((prevVar: boolean) => boolean)) => void;
};

export const AppLayoutContext = createContext<AppLayoutContextType>({
  sidebarIsOpen: false,
  sidebarIsFixed: false,
  scrollRef: null,
  setSidebarIsFixed: () => {
    return;
  },
  setSidebarIsOpen: () => {
    return;
  },
});

export const AppLayoutContextProvider = ({ children }: { children: ReactNode }) => {
  const scrollRef = useRef<HTMLDivElement | null>(null);

  const [sidebarIsOpen, setSidebarIsOpen] = useState(false);
  const [sidebarIsFixed, setSidebarIsFixed] = useState(false);

  return (
    <AppLayoutContext.Provider
      value={{
        sidebarIsFixed,
        sidebarIsOpen,
        setSidebarIsOpen,
        setSidebarIsFixed,
        scrollRef,
      }}
    >
      {children}
    </AppLayoutContext.Provider>
  );
};
